import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createSec9InterimOrdersAPI,
  updateSec9InterimOrdersAPI,
  getSec9InterimOrdersByCaseIDAPI,
  deleteSec9InterimOrdersAPI,
} from "../../../api/Sec9Interimorders_api";

export const getSec9InterimOrdersByCaseIDAction = createAsyncThunk(
  "sec9InterimOrders/getSec9InterimOrdersByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getSec9InterimOrdersByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createSec9InterimOrdersAction = createAsyncThunk(
  "sec9InterimOrders/createSec9InterimOrders",
  async (arbitratorDetailsData, { rejectWithValue }) => {
    const response = await createSec9InterimOrdersAPI(arbitratorDetailsData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateSec9InterimOrdersAction = createAsyncThunk(
  "sec9InterimOrders/updateSec9InterimOrdersAPI",
  async (
    { sec9InterimOrders_ID, sec9InterimOrdersData },
    { rejectWithValue },
  ) => {
    const response = await updateSec9InterimOrdersAPI(
      sec9InterimOrders_ID,
      sec9InterimOrdersData,
    );

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteSec9InterimOrdersAction = createAsyncThunk(
  "sec9InterimOrders/deleteSec9InterimOrders",
  async (sec9InterimOrders_ID, { rejectWithValue }) => {
    const response = await deleteSec9InterimOrdersAPI(sec9InterimOrders_ID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
